/**
 * Small text helpers shared by authoring, AI insight cards, and SVG tooltips.
 */
export function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function summarizeEditedParagraph(paragraph) {
  const clean = String(paragraph || '').trim()
  if (!clean) return ''
  const firstSentence = clean.match(/^[^.!?]+[.!?]/)
  return firstSentence ? firstSentence[0] : clean.slice(0, 160)
}

export function cleanDraftText(value, maxLength = 1200) {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, maxLength)
}
